import {
  updateProveedorEstatus,
  getProveedoresAll,
  newProveedor,
  getProveedorById,
  updateProveedor,
} from "../services/serviceProveedores";

const dataInicial = {
  array: [],
  exito: 0,
  proveedor: {},
};

const POST_PROVEEDOR_ADD = "POST_PROVEEDOR_ADD";
const PUT_PROVEEDOR = "PUT_PROVEEDOR";
const GET_PROVEEDOR_ALL = "GET_PROVEEDOR_ALL";
const GET_PROVEEDOR_BY_ID = "GET_PROVEEDOR_BY_ID";
const DELETE_PROVEEDOR = "DELETE_PROVEEDOR";
const CLEAR_PROVEEDOR_ALL = "CLEAR_PROVEEDOR_ALL";

export default function proveedorReducer(state = dataInicial, action) {
  switch (action.type) {
    case GET_PROVEEDOR_BY_ID:
      return { ...state, proveedor: action.payload.proveedor };
    case DELETE_PROVEEDOR:
      return {
        ...state,
        array: action.payload.array,
        exito: action.payload.exito,
      };
    case CLEAR_PROVEEDOR_ALL:
      return {
        ...state,
        array: action.payload.array,
        exito: action.payload.exito,
      };
    case GET_PROVEEDOR_ALL:
      return { ...state, array: action.payload.array };
    case POST_PROVEEDOR_ADD:
      return {
        ...state,
        exito: action.payload.exito,
        array: action.payload.array,
      };
    case PUT_PROVEEDOR:
      return {
        ...state,
        exito: action.payload.exito,
        array: action.payload.array,
      };
    default:
      return state;
  }
}

export const actulizaProveedorAction =
  (payload, idProveedor) => async (dispatch) => {
    const response = await updateProveedor({ payload, idProveedor });
    const newProveedores = await getProveedoresAll();
    dispatch({
      type: PUT_PROVEEDOR,
      payload: {
        array: newProveedores,
        exito: 1,
      },
    });
    return response;
  };

export const altaProveedorAction = (payload) => async (dispatch) => {
  const response = await newProveedor({ payload });
  const newProveedores = await getProveedoresAll();
  dispatch({
    type: POST_PROVEEDOR_ADD,
    payload: {
      array: newProveedores,
      exito: 1,
    },
  });
  return response;
};
export const eliminarProveedorAction =
  (idProveedor, Estatus) => async (dispatch) => {
    const response = await updateProveedorEstatus({ idProveedor, Estatus });
    const newProveedores = await getProveedoresAll();
    dispatch({
      type: DELETE_PROVEEDOR,
      payload: {
        array: newProveedores,
        exito: 1,
      },
    });
    return response;
  };

export const obtenerProveedoresAllAction = () => async (dispatch) => {
  const proveedores = await getProveedoresAll();
  dispatch({
    type: GET_PROVEEDOR_ALL,
    payload: {
      array: proveedores,
    },
  });
  return proveedores;
};

export const obtenerProveedoresByIdAction =
  (idProveedor) => async (dispatch) => {
    const proveedor = await getProveedorById({ idProveedor });
    dispatch({
      type: GET_PROVEEDOR_BY_ID,
      payload: {
        proveedor: proveedor,
      },
    });
    return proveedor;
  };

export const clearState = () => (dispatch) => {
  dispatch({
    type: CLEAR_PROVEEDOR_ALL,
    payload: {
      dataInicial,
    },
  });
};
